export const queryUrlParams = ({ location }) => location.pathname.split('/').pop();



// WEBPACK FOOTER //
// ./src/components/VerificationPage/helpers.js